<template>
  <div @click="clickOutside">
    <input
    class="bg-light-gray h-[20px] w-[76px] text-[13px] rounded-sm outline-hidden px-2 text-center border-none"
    v-model.trim="selectedPublishOption"
    id="editableSelect"
    autocomplete="off"
    placeholder=""
    ref="input"
    @keyup.enter="onInputKeyupEnter"
    @focus="toggleDropdown"
    @blur="closeDropdownWithDelay"
    />
    <ul
      ref="publishOptions"
      id="dropdown"
      :class="{
        'text-[13px] w-full h-[200px] flex flex-wrap justify-center overflow-y-scroll mt-1 border border-[#e4e7ed] rounded-sm shadow-sm py-[6px] content-start': true,
        'hidden': !isOptionsVisible
      }">

      <!-- All Player Option -->
      <li
        v-if="allPlayerOption"
        :class="{
          'w-full text-left relative text-[12px] leading-[22px] m-[2px] ml-3 text-white': true,
          'hidden': allPlayerOption._edit.hideByTagUserRights,
          'opacity-40': allPlayerOption._edit.notSupported,
        }">
        <div class="inline-block relative cursor-pointer" @click="onOptionSelect(allPlayerOption)">
          <div
            class="absolute w-full h-full rounded-sm top-0"
            :style="{backgroundColor: allPlayerOption._edit.backgroundColor}">
          </div>
          <div class="relative h-full w-full px-2 bg-white/20 hover:bg-transparent">
            {{ $t('label.allPlayers') }}
          </div>
        </div>

        <el-tooltip v-if="allPlayerOption._edit.notSupported"
          :popper-class="'custom-tooltip-popper-filters'"
          :show-arrow="false"
          :content="$t('label.contentNotSupported')"
          effect="light"
          class="item"
          placement="top">
          <button class="border-0 bg-transparent text-black opacity-40 hover:opacity-100 h-[22px] align-middle cursor-pointer" @click.prevent="handleWarningClicked"><el-icon :size="20"><Warning /></el-icon></button>
        </el-tooltip>
      </li>

      <!-- Player groups are only for premium/enterprise accounts -->
      <template v-if="!isDiscoveryAccount">
        <!-- Divider between ALL Player option and Player groups -->
        <div class="w-full border-b border-[#e0e3ea] p-1" v-if="allPlayerOption && (unselectedPlayerGroups.length || hasNoSearchMatchForPlayerGroups)"></div>

        <!-- Label for Player groups -->
        <p
          v-if="hasPlayerGroupLabel"
          class="w-full leading-4 text-[#9fa0ad] text-[10px] font-semibold mx-3 my-2 text-left uppercase">
          {{ $t('label.playerGroups') }}
        </p>

        <!-- Note if no player groups available OR if no results for player group filtering-->
        <p v-if="!hasActivePlayerGroups || hasNoSearchMatchForPlayerGroups" class="font-semibold leading-4 mx-3 my-2 text-[#9fa0ad] text-[10px] w-full uppercase">{{ $t('label.noPlayerGroupsAvailable') }}</p>

        <!-- List of all Player groups -->
        <li
          v-for="option in filteredPlayerGroups"
          :class="{
            'relative text-[12px] leading-[22px] cursor-pointer m-[2px]': true,
            'hidden': option._edit.hideByTagUserRights,
            'opacity-40': option._edit.notSupported,
            }"
          :key="option.name"
          :value="option.name"
          @click="onOptionSelect(option)">
          <div
            class="absolute w-full h-full rounded-sm top-0"
            :style="{ backgroundColor: getPlayerTagsColor(option.name, option._edit.backgroundColor)}">
          </div>
          <div class="relative h-full w-full px-2 bg-white/80 hover:bg-transparent">
            {{ option.name }}
          </div>
        </li>

        <!-- Divider between player groups and players -->
        <div class="w-full border-b border-[#e0e3ea] p-1" v-if="hasPlayerGroupLabel && (unselectedPlayers.length || hasNoSearchMatchForPlayers)"></div>
      </template>

      <!-- Label for Players -->
      <p
        v-if="unselectedPlayers.length > 0 || !hasInstalledPlayers || hasNoSearchMatchForPlayers"
        class="w-full leading-4 text-[#9fa0ad] text-[10px] font-semibold mx-3 my-2 text-left uppercase">
        {{ $t('label.player', 2) }} {{ ledResolutionLabel }}
      </p>

      <!-- If no players installed OR if no results for players filtering -->
      <p v-if="!hasInstalledPlayers || hasNoSearchMatchForPlayers" class="font-semibold leading-4 mx-3 my-2 text-[#9fa0ad] text-[10px] w-full uppercase">{{ $t('label.noPlayersInstalled') }} {{ ledResolutionLabel }}</p>

      <!-- List of all Players -->
      <li
        v-for="option in filteredPlayers"
        :class="{
          'relative text-[12px] leading-[22px] m-[2px] ml-3 w-full text-left': true,
          'hidden': option._edit.hideByTagUserRights,
          'opacity-40': option._edit.notSupported,
        }"
        :key="option.name"
        :value="option.name">
        <div class="inline-block relative cursor-pointer" @click="onOptionSelect(option)">
          <div
            class="absolute w-full h-full rounded-sm top-0"
            :style="{ backgroundColor: getPlayerTagsColor(option.name, option._edit.backgroundColor)}">
          </div>
          <div class="relative h-full w-full px-2 bg-white/80 hover:bg-transparent">
            {{ option.name }}
          </div>
        </div>
        <el-tooltip v-if="option._edit.notSupported"
          :popper-class="'custom-tooltip-popper-filters'"
          :show-arrow="false"
          :content="$t('label.contentNotSupported')"
          effect="light"
          class="item"
          placement="top">
          <button class="border-0 bg-transparent text-black opacity-40 hover:opacity-100 h-[22px] align-middle cursor-pointer" @click.prevent="handleWarningClicked"><el-icon :size="20"><Warning /></el-icon></button>
        </el-tooltip>
      </li>
    </ul>
  </div>
</template>

<script src="./publish-selection-menu-item.js"></script>
<style scoped>
ul#dropdown::-webkit-scrollbar {
  width: 6px;
}

ul#dropdown::-webkit-scrollbar-thumb {
  background: hsla(220,4%,58%,.3);
  border-radius: 100vh;
  cursor: pointer;

  &:hover {
    background: hsla(220,4%,58%,.5);
  }
}
</style>
